import * as $ from 'jquery';

import { Component, OnInit,Inject,Input,ComponentRef } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { GpsLoggerBottomSheetComponent } from '../gps-logger-bottom-sheet/gps-logger-bottom-sheet.component';
import { RearCameraBottomSheetComponent } from '../rear-camera-bottom-sheet/rear-camera-bottom-sheet.component';
import { CartItemsService } from 'src/app/services/cart-items.service';
import { environment } from 'src/environments/environment.test';
import { GetProductService } from 'src/app/services/product/get-product.service';
import { NewProduct, ProductResponse, ProductCart, updateCart } from 'src/app/models/product';
import { Utils } from 'src/app/Utils';
import { Cart } from 'src/app/models/cart';
import { AppConfigService } from 'src/app/app-config.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Overlay, OverlayPositionBuilder } from '@angular/cdk/overlay';
import { CookieService } from 'ngx-cookie-service';
import { OrderService } from 'src/app/services/orders.service';
import { ActivatedRoute, Router,NavigationEnd,Route} from '@angular/router';
import { ExternalRouterService } from 'src/app/services/external-router.service';
import { AuthService } from 'src/app/services/auth.service';
import { GetCartService } from 'src/app/services/cart/get-cart.service';
import { ApiResponse } from 'src/app/models/cart';
import { SharingService } from 'src/app/services/sharing.service';
import { ComponentPortal } from '@angular/cdk/portal';
import { ApplicationStateService } from 'src/app/services/application-state.service';
import { ProductService } from 'src/app/services/product/product.serivce';
import { ProductDetailClaimComponent } from 'src/app/shared/product-detail-claim/product-detail-claim/product-detail-claim.component';
import { MessageService } from 'src/app/shared/product-detail-claim/product-detail-claim/message.service';
@Component({
  selector: 'app-dashcam-accessories',
  templateUrl: './dashcam-accessories.component.html',
  styleUrls: ['./dashcam-accessories.component.scss'],
})
export class DashcamAccessoriesComponent implements OnInit {
  cartItems = 0; 
  @Input() products;
    product;
    loaded2 = true;
    postCart = new Cart();
    cart;
    miniVariants: any[] = [];
    featuredProducts: any = [];
    productQuantities: { [key: string]: number } = {};
    offeredPrice: number;
    gpsLoggerPrice: number;
    rearCameraPrice: number;
    vidsurePrice:number;
  constructor(private bottomSheetRef: MatBottomSheetRef<DashcamAccessoriesComponent>,private bottomSheet:MatBottomSheet,
    private cartItemsService: CartItemsService,
    private _overlay: Overlay,
    private externalRouter: ExternalRouterService,
    private orders: OrderService,
    private router: Router,
    private getProductService: GetProductService,
     public _cookie: CookieService,
     private cdRef: ChangeDetectorRef,
     private messageService: MessageService,
     private sharingService: SharingService,
     private cookieService: CookieService,
     private authService: AuthService,
     private positionBuilder: OverlayPositionBuilder,
     private authenticationService: AuthService,
     private getCartService: GetCartService,
     private cartService: GetCartService,
     private productService: ProductService,
     private appConfigService: AppConfigService,
     private cdr: ChangeDetectorRef,
     private applicationStateService: ApplicationStateService,
     @Inject(MAT_BOTTOM_SHEET_DATA) public data: any
  ) {
    this.productId = data.productId || null;
    this.addedRearCamera = data.addedRearCamera || false;
    this.addedGPSLogger = data.addedGPSLogger || false;
    this.offeredPrice = data.offeredPrice;
    this.totalPrice=data.totalPrice;
    this.gpsLoggerPrice = data.gpsloggerprice || 0;
    this.rearCameraPrice = data.vidsureRearcamPrice || 0;
    this.vidsurePrice = data.vidsureOfferedPrice || 0; 
    this.accessoryCount = data.accessoryCount || 0; 
    // console.log("Received data in Bottom Sheet:");
    // console.log("Product ID:", this.productId);
    // console.log("Rear Camera Added:", this.addedRearCamera);
    // console.log("GPS Logger Added:", this.addedGPSLogger);
    // console.log("Received Data in Bottom Sheet:", data);
  }
  @Input() productId: string; 
ngOnInit() {
    // this.loadCart();
    this.loadCartCount();
    // this.loadcartdata();
    // console.log('cartItems:', this.cartItems);
    this.changeUniqueVariant();
    // this.cartService.cartItems$.subscribe(cartCount => {
    //   this.cartItems = cartCount;
    //   console.log("cartitems count",this.cartItems);
    // });
    // this.productService.productDetail$.subscribe((response) => {
    //   this.loadProductDetails(response); // Call the async function
    // });
    // this.productService.allProducts$.subscribe(res => {
    //   // console.log("all-product-m")
    //   this.products = res;
    //   this.miniVariants = res;
    //   this.featuredProducts = res;

    // });
  
}


closeBottomSheet(): void {
  // console.log("🚀 Closing Bottom Sheet - Product ID (Before Update):", this.data.productId);

  // Ensure the correct product ID is set
  // this.changeUniqueVariant();

  setTimeout(() => {
    // console.log("✅ Updated Product ID Before Closing:", this.data.productId);

    const finalProductId = this.data.productId; // Save correct product ID

    this.bottomSheetRef.dismiss({
      selectedAccessories: {
        rearCamera: this.addedRearCamera,
        gpsLogger: this.addedGPSLogger
      },
      variantId: finalProductId, // Ensure correct product ID is passed
      totalPrice: this.totalPrice,
      accessoryCount: this.accessoryCount
    });

    // console.log("📩 Sent Product ID:", finalProductId);
  }, 100); // Delay to ensure updates apply
}






  
openGpsLoggerBottomSheet(): void {
  this.bottomSheet.open(GpsLoggerBottomSheetComponent);
}
openRearCameraBottomSheet(): void {
  this.bottomSheet.open(RearCameraBottomSheetComponent);
}
  
async loadProductDetails(res: any) {
    try {
     
      this.variantProducts = res.variants.body.map(element => ({ ...element }));
 
      let fetchedProduct = res.productRes;
      this.product = { ...fetchedProduct };
      this.data = fetchedProduct.features;
    
 
      // Handle route-specific data
      
 
     
 
     //  console.log("Product loaded:", this.product);
    } catch (error) {
      console.error("Error fetching product details:", error);
    }
}

buy() {
      this.cartItems++;
      this.loaded2 = false; 
         if (environment.MAGIC_CHECKOUT_ENABLED) {
           // if (!this.Pid) {
           //   this.Pid = this.product.productId;
           //   this._cookie.set('productId', this.product.productId);
           //   this.postCart.cartItemId = '';
           //   this.postCart.cartId = '',
           //   this.postCart.productId = this._cookie.get('productId');
     
           //   if (!this._cookie.get('cartId')) {
           //     this.getCartService.postCart('', this.postCart.productId).subscribe(data => {
           //       this.cartItemService.updateApprovalMessage(data);
           //       this.sharingService.updateApprovalMessage(data);
           //       this._cookie.set('cartId', data.body.cartId);
           //         this.navigateToCheckout()
           //     });
     
           //   } else {
           //     this.getCartService.postCart(this._cookie.get('cartId'), this.postCart.productId).subscribe(data => {
           //       this.cartItemService.updateApprovalMessage(data);
           //       this.sharingService.updateApprovalMessage(data);
           //       this.navigateToCheckout()
           //     });
           //   }
           // }
           const btn = (document.getElementById(this.product.productId) as HTMLButtonElement);
     
           if (btn) {
             btn.disabled = true;
           }
           let createMagicOrderSpinner = Utils.getDotElasticComponent(this._overlay, this.positionBuilder);
           Utils.buyNow(this.orders, '', this.product.productId, this.router, this._overlay, this.positionBuilder, this.externalRouter, createMagicOrderSpinner)
         } else {
           let isAuth = this.authService.canActivate()
           if (isAuth) {
            
             Utils.checkOutInMobile(this.product.productId, this.authService, this.cookieService, this.externalRouter)
           }
         }
         this.bottomSheetRef.dismiss(); 
         this.addToCart(this.product);

}
// loadcartdata(){
//   // console.log("Loading card data");
//   this.cartItemsService.currentApprovalStageMessage.pipe( debounceTime(500), distinctUntilChanged() ).subscribe(
//     data => {
//       this.loaded2 = false; // Start loading state
//       this.cartItems = 0; // Default reset for cartItems
     
//       if (data==="mess" && this._cookie.get('cartId')) {
//         // console.log("Inside IF condition ")
//         this.cartService.getCart().pipe( debounceTime(500), distinctUntilChanged() ).subscribe(
//           x => { 
//             this.cart = x.body;
//             if (this.cart && this.cart.products) {
//               this.cartItems = this.cart.products.reduce((total, product) => total + product.quantity, 0);
//               this.productQuantities = this.cart.products.reduce((quantities, product) => {
//                 if (product.product && product.product.productId) {
//                   quantities[product.product.productId] = product.quantity;
//                 } else {
//                   console.warn('Missing product or productId for product:', product);
//                 }
//                 return quantities;
//               }, {}); 
//             }
//             this.loaded2 = true; // Data has loaded
//           },
//           error => {
//             console.log('Error fetching cart:', error);
//             this.loaded2 = true; // Ensure UI updates even on error
//           }
//         );
//       } else if (data.body && data.body.products) {
//         this.cartItems = data.body.products.reduce((total, product) => total + product.quantity, 0);
//         this.loaded2 = true; // Data has loaded
//       } else {
//         this.cartItems = 0;
//         this.loaded2 = true; // Data has loaded (even if empty)
//       }
//     },
//     error => {
//       console.log('Error in approval stage message handling:', error);
//       this.loaded2 = true; // Ensure UI updates even on error
//     }
//   );
// }
selectedProduct(dataFromChild) {
  if (dataFromChild) {

    this.product = dataFromChild;
    //TODO: change counter of deal
    this.changeUniqueVariants()
    // this.changeVideo();       //TODO
    //this.product.images.splice(0, 0, this.video);  
  }

}
variantProducts: any[] = []
changeUniqueVariants() {
    
    
  this.getProductService.getVariantProduct(this.product.variantId).subscribe(data => {
    this.variantProducts = [];
   
    data.body.forEach((element: any) => this.variantProducts.push(Object.assign({}, element)));
    
  }, error => {
 console.error(error);
    
  });
}


addToCart(product: any) {
  // Disable user interactions temporarily
  $("#_page").css('pointer-events', 'none');
  this.loaded2 = false;
  this.loaded3 = false; // Start loader

  // Check if Magic Checkout is enabled
  if (environment.MAGIC_CHECKOUT_ENABLED) {
    Utils.addToCartIfLandedFromQuickbuy(this.externalRouter);

    // Set productId in cookies
    this._cookie.set('productId', product.productId);

    // Prepare the postCart object
    this.postCart.productId = product.productId;

    // Retrieve cartId from cookies
    const cartId = this._cookie.get('cartId');

    if (!cartId) {
      // console.warn("Cart ID is missing. Creating a new cart...");

      // Create a new cart and add the product
      this.getCartService.postCart('', this.postCart.productId).pipe(debounceTime(500), distinctUntilChanged()).subscribe({
        next: (data) => {
          // Save the new cartId in cookies
          this._cookie.set('cartId', data.body.cartId);
          this.cart = data.body;

          // Add product to the local cart
          this.productQuantities[product.productId] = 1;
          this.cartItems = data.body.products.length;
        },
        error: (error) => console.error("Error creating new cart:", error),
        complete: () => {
          $("#_page").css('pointer-events', 'auto');
          this.loaded2 = true;
          this.loaded3 = true; // Stop loader
          this.bottomSheetRef.dismiss();
          this.router.navigate(['/cart']);
        }
      });
    } else {
      // Add product to the existing cart
      this.getCartService.postCart(cartId, this.postCart.productId).pipe(debounceTime(500), distinctUntilChanged()).subscribe({
        next: (data) => {
          this.cart = data.body;
          this.cartItemsService.updateApprovalMessage(data);
          this.sharingService.updateApprovalMessage(data);

          // Check if the product is already in the cart
          let existingProduct = data.body.products.find(item => item.productId === product.productId);

          if (existingProduct) {
            // Update the existing product's quantity
            this.productQuantities[product.productId] = existingProduct.quantity;
          } else {
            // Add new product to local quantities with quantity 1
            this.productQuantities[product.productId] = 1;
          }

          // Update the total cart items
          this.cartItems = data.body.products.length;
        },
        error: (error) => console.error("Error adding product to cart:", error),
        complete: () => {
          $("#_page").css('pointer-events', 'auto');
          this.loaded2 = true;
          this.loaded3 = true; // Stop loader
          this.bottomSheetRef.dismiss();
          this.router.navigate(['/cart']);
        }
      });
    }
  } else {
    // Handle mobile checkout if Magic Checkout is disabled
    Utils.checkOutInMobile(product.productId, this.authService, this.cookieService, this.externalRouter);
    $("#_page").css('pointer-events', 'auto');
    this.loaded2 = true;
    this.loaded3 = true; // Stop loader
    this.bottomSheetRef.dismiss();
    this.router.navigate(['/cart']);
  }
}

   


claimRewardNow() {
        const overlayRef = this._overlay.create({
          hasBackdrop: true,
          positionStrategy: this.positionBuilder.global().centerHorizontally().centerVertically(),
        })
        const dialogPortal = new ComponentPortal(ProductDetailClaimComponent);
    
        const ref: ComponentRef<ProductDetailClaimComponent> = overlayRef.attach<ProductDetailClaimComponent>(dialogPortal);
        overlayRef.backdropClick().subscribe(() => overlayRef.detach());
        this.messageService.attachOverlayRef(overlayRef);
}




// loadCart() { 
//         const cartId = this._cookie.get('cartId'); // Get cartId from cookies
//         // this.loaded2 = false;
//       if (!cartId) {
//         // console.warn("No cartId found. Skipping cart load.");
//         this.cart = { products: [] }; // Reset cart data
//         this.cartItems = 0;
//         this.productQuantities = {};
//         this.loaded2 = true;
//         return;
//       } 
       
      
//         this.cartService.getCart().pipe( debounceTime(500), distinctUntilChanged() ).subscribe(
//           (cartData) => {
//             this.cart = cartData.body || { products: [] }; 
      
//             // Calculate total quantity of all products in the cart
//             this.cartItems = this.cart.products.reduce((total, product) => total + product.quantity, 0);
//             this.cartService.updateCartItems(this.cartItems);
      
//             // Map product quantities for all products
//             this.productQuantities = this.cart.products.reduce((quantities, product) => {
//               if (product && product.product && product.product.productId) { 
//                 quantities[product.product.productId] = product.quantity;
//               } else {
//                 console.warn("Missing product or productId for product:", product);
//               }
//               return quantities;
//             }, {});
      
//             this.loaded2 = true; // Data has loaded
//           },
//           (error) => {
//             console.error("Error fetching cart:", error);
//             this.loaded2 = true; 
//           }
//         );
//         // this.cartService.cartItems$.subscribe(cartCount => {
//         //   this.cartItems = cartCount;
          
//         // });
//         console.log('cartItems:', this.cartItems);
// }
loadCartCount() { 
  const cartId = this._cookie.get('cartId'); // Get cartId from cookies
  
  if (!cartId) {
      this.cartItems = 0;
      console.warn("No cartId found. Skipping cart count update.");
      return;
  } 
  // this.cartService.cartItems$.subscribe(cartCount => {
  //   this.cartItems = cartCount;
  //   console.log("cartitems count",this.cartItems);
  // });
  this.cartService.getCart().subscribe(
      (cartData) => {
          if (cartData && cartData.body && cartData.body.products) {
              this.cartItems = cartData.body.products.reduce(
                  (total, product) => total + (product.quantity || 0), 0
              );
          } else {
              this.cartItems = 0;
          }
        
          console.log("Cart Items Count (Updated):", this.cartItems);
          this.cdr.detectChanges();
      },
      (error) => {
          console.error("Error fetching cart count:", error);
      }
  );
}

addedRearCamera: boolean = false;
addedGPSLogger: boolean = false;

  totalPrice:number;
  accessoryCount:number;
selectAccessories(accessory: 'rearCamera' | 'gpsLogger', isAdding: boolean) {
    if (accessory === 'rearCamera') {
        this.addedRearCamera = isAdding;
         
    } else if (accessory === 'gpsLogger') {
        this.addedGPSLogger = isAdding;
        
        
    }
    this.updateAccessorySummary();
    this.changeUniqueVariant();
   
}
updateAccessorySummary() {
  this.accessoryCount = 0;
  this.totalPrice = 0;

  if (this.addedRearCamera) {
    this.accessoryCount++;
    this.totalPrice +=  this.data.vidsureRearcamPrice || 0;
  }
  if (this.addedGPSLogger) {
    this.accessoryCount++;
    this.totalPrice += this.data.gpsloggerprice || 0;
  }
}
  
  
  selectedVariant: string=this.data.productId;

selectVariant(variant: string) {
    if (this.selectedVariant === variant) {
        this.selectedProduct = null; 
    }

    this.selectedVariant = variant;

    
        this.changeUniqueVariant(); // Ensure the correct product variant is fetched
    
}




  
 
changeUniqueVariant() {
  
  let variantId = this.selectedVariant; // Default to selected variant

  // Determine the correct variant based on accessories
  if (this.addedRearCamera && this.addedGPSLogger && this.selectedVariant === 'hardwire') {
      variantId = 'ol_vs_r_log_hk';
  } else if (this.addedRearCamera && this.selectedVariant === 'hardwire') {
      variantId = 'ol_vs_r_hk';
  } else if (this.addedGPSLogger && this.selectedVariant === 'hardwire') {
      variantId = 'ol_vs_log_hk';
  } else if (this.addedRearCamera && this.addedGPSLogger && this.selectedVariant != 'hardwire') {
      variantId = 'ol_vs_r_log_cc';
  } else if (this.addedRearCamera && this.selectedVariant != 'hardwire') {
      variantId = 'ol_vs_r_cc';
  } else if (this.addedGPSLogger && this.selectedVariant != 'hardwire') {
      variantId = 'ol_vs_log_cc';
  }
  else if(this.selectedVariant != 'hardwire'){
      variantId='ol_vs_cc'
  }else {
    variantId='ol_vidsure';
  }
  this.data.productId = variantId;
  // console.log("Fetching product in dashcam variant with ID:", variantId);
 this.changeCarousel1(variantId); 
  
}
loaded3=true;
changeCarousel1(productId) {
  this.loaded3 = false;
  this.getProductService.getProduct(productId).subscribe(
    (data) => {
      if (data && data.body) {
        this.product = data.body;
       
          this.loaded3 = true;
          this.cdRef.detectChanges();
         // Delay to let Angular process updates
      }
    },
    (error) => {
      console.error("API error in changeCarousel1:", error);
     
        this.loaded3 = true;
        this.cdRef.detectChanges();
      
    }
  );
}


  // putValues(data: ApiResponse<CartDto>) {
  //    this.deliveryDate = new Date();
  //    this.deliveryDate.setDate(this.deliveryDate.getDate() + Constants.SEVEN_DAYS + 1);
  //    if (data.body.fastDeliveryApplied) {
  //      this.deliveryCharge = data.body.deliveryCharge;
  //      this.lightening = true;
  //      this.deliveryDate = new Date();
  //      this.deliveryDate.setDate(this.deliveryDate.getDate() + Constants.THREE_DAYS);
  //      this.deliveryDate = this.checkdate(this.deliveryDate);
  //    }
  //    this.mrp = data.body.mrpValue;
  //    this.discount = data.body.discountValue;
  //    this.total = data.body.offeredValue;
  //    this.couponDiscount = data.body.couponValue;
  //    this.grandTotal = data.body.cartFinalValue;
  //    this.items = data.body.products.length;
  //    this.productQuant = data.body.products;
  //    this.loaded = true;
 
  //    if (data.body.coupon) {
  //      this.showCoupon = !this.showCoupon;
  //      this.coupondesc = data.body.coupon.couponTitle.toUpperCase() == "FLAT100 OFF" ? this._cookie.get('coupon').split(" ")[0] + "100OFF" : data.body.coupon.couponTitle;
  //    }
  //    for (let i = 0; i < data.body.products.length; i++) {
  //      this.products.push({
  //        mrp: data.body.products[i].product.mrp,
  //        name: data.body.products[i].product.name,
  //        starRating: data.body.products[i].product.starRating,
  //        price: data.body.products[i].product.mrp,
  //        images: data.body.products[i].product.images[0].path,
  //        offeredPrice: data.body.products[i].product.offeredPrice,
  //        variantName: data.body.products[i].product.variantName
  //      });
 
  //    }
  //    if (!data.body.coupon) {
  //      this.couponDiscount = 0;
  //    }
  //    if (data.body.onelapCoins) {
  //      this.money = false;
  //    } else {
  //      this.money = true;
  //    }
  //    if (data.body.coupon) {
  //      this.showCoupon = true;
  //    }
  //  }
gotoCart() {
  
  const isMagicCheckoutEnabled = this.appConfigService.config.MAGIC_CHECKOUT_ENABLED != null
    ? this.appConfigService.config.MAGIC_CHECKOUT_ENABLED
    : environment.MAGIC_CHECKOUT_ENABLED;

  if (isMagicCheckoutEnabled) { 
    let x = Utils.isLandedFromQuickBuyLink(this.externalRouter);
    if (x) {
      return;
    }
    this.router.navigate(['/cart']);
  }
  else {
    if (this.applicationStateService.getIsMobileResolution()) {
      Utils.checkOutInMobile('', this.authenticationService, this._cookie, this.externalRouter);
    }
    else {
      Utils.checkOutInDesktop("", this._cookie, this.externalRouter);
    }
  }
}

}
